/** Preferenze retta in fattura (amministrativa.fatturazione_retta). */

export const MODALITA_RETTA = [
  { value: "intera", label: "Importo intero (residuo del mese)" },
  { value: "parziale", label: "Importo fisso personalizzato" },
  { value: "senza_importo", label: "Solo descrizione (importo zero)" },
  { value: "esclusa", label: "Non includere la retta" },
];

export function defaultPreferenzeFatturazioneRetta() {
  return {
    includi_retta: true,
    modalita: "intera",
    importo_parziale: null,
    voci_incluse: null,
  };
}

export function normalizePreferenzeFatturazioneRetta(raw) {
  const base = defaultPreferenzeFatturazioneRetta();
  if (!raw || typeof raw !== "object") return base;
  const modalita = MODALITA_RETTA.some(m => m.value === raw.modalita) ? raw.modalita : base.modalita;
  let includi_retta = raw.includi_retta;
  if (includi_retta == null) includi_retta = modalita !== "esclusa";
  if (modalita === "esclusa") includi_retta = false;
  let importo_parziale = raw.importo_parziale;
  if (importo_parziale === "" || importo_parziale == null) {
    importo_parziale = null;
  } else {
    const n = parseFloat(String(importo_parziale).replace(",", "."));
    importo_parziale = Number.isFinite(n) && n > 0 ? n : null;
  }
  let voci_incluse = raw.voci_incluse;
  if (voci_incluse == null) voci_incluse = null;
  else if (Array.isArray(voci_incluse)) voci_incluse = voci_incluse.filter(Boolean);
  else voci_incluse = null;
  return { includi_retta, modalita, importo_parziale, voci_incluse };
}

/** Mappa preferenze fascicolo → parametri API fatturazione (anteprima / genera). */
export function preferenzeToRettaApiParams(prefs, { hasVociRettaConfig = false } = {}) {
  const p = normalizePreferenzeFatturazioneRetta(prefs);
  const params = { includi_retta: p.includi_retta };
  if (!p.includi_retta) return params;
  if (p.modalita === "parziale" && p.importo_parziale != null) {
    params.importo_retta = p.importo_parziale;
  }
  if (p.modalita === "senza_importo") {
    params.retta_senza_importo = true;
  }
  if (hasVociRettaConfig && Array.isArray(p.voci_incluse)) {
    params.voci_retta_incluse = p.voci_incluse.join(",");
  }
  return params;
}

/** Mappa preferenze fascicolo → stato iniziale dialog Genera fattura. */
export function preferenzeToGeneraFormRetta(prefs, { rettaResidua = null, vociRettaConfig = [] } = {}) {
  const p = normalizePreferenzeFatturazioneRetta(prefs);
  const tutteVoci = vociRettaConfig.map(v => v.id).filter(Boolean);
  let importo_retta_parziale = "";
  if (p.modalita === "parziale" && p.importo_parziale != null) {
    importo_retta_parziale = String(p.importo_parziale);
  } else if (rettaResidua != null && rettaResidua > 0) {
    importo_retta_parziale = String(rettaResidua);
  }
  const voci_retta_incluse =
    Array.isArray(p.voci_incluse) && p.voci_incluse.length > 0 ? p.voci_incluse : tutteVoci;
  return {
    includi_retta:
      p.modalita !== "esclusa" &&
      p.includi_retta &&
      (rettaResidua == null || rettaResidua > 0),
    retta_modalita: p.modalita === "esclusa" ? "intera" : p.modalita,
    importo_retta_parziale,
    voci_retta_incluse,
  };
}

export function labelModalitaRetta(modalita) {
  return MODALITA_RETTA.find(m => m.value === modalita)?.label || modalita;
}
